<template>
  <b-modal
    id="medicationInformation"
    v-model="show"
    centered
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
  >
    <template #modal-header>
      <h5 class="modal-title">Medication Information</h5>
      <button
        type="button"
        class="close"
        @click="$emit('onCloseModal') && (logData = [])"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div class="employerTable-card p-0 mt-0 mb-3 table-responsive">
      <table class="table">
        <thead>
          <tr>
            <!-- <th>Member Id</th> -->
            <th>SN</th>
            <th>Type</th>
            <th>Name</th>
            <th>Medication</th>
            <th>Dosage</th>
            <th>Medical Condition</th>
            <th>Additional Notes</th>
          </tr>
        </thead>
        <tbody v-if="logData.length == 0">
          <tr class="text-center">
            <td colspan="8" class="text-center">No Records Found</td>
          </tr>
        </tbody>
        <tbody v-for="(logs, index) in logData" :key="logs.id">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>
              {{
                logs.dep_relation == "C"
                  ? "Child"
                  : logs.dep_relation == "S"
                  ? "Spouse"
                  : "Primary"
              }}
            </td>
      <td>
        {{
          logs.dep_relation
            ? logs.dep_fname + (logs.dep_mname ? " " + logs.dep_mname : "") + " " + logs.dep_lname
            : logs.user_fname + (logs.user_mname ? " " + logs.user_mname : "") + " " + logs.user_lname
        }}
      </td>
            <td>
              {{ logs.medication || "" }}
            </td>
            <td>{{ logs.dosage || "" }}</td>
            <td>{{ logs.medical_condition || "" }}</td>
            <td>{{ logs.additional_notes || "" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
import Api from "@/resource/Api";
export default {
  name: "MedicationModal",
  props: {
    show: { type: Boolean, default: false },
    row: { type: Object, default: () => {} },
  },
  data() {
    return {
      data: null,
      internalShow: this.show,
      logData: [],
    };
  },
  watch: {
    show(newVal) {
      if (newVal && this.row.policy_id) {
        this.getMedication();
      }
    },
  },
  methods: {
    async getMedication() {
      let loader = this.$loading.show();
      const url = "v2/get-medications/" + this.row.policy_id;
      try {
        const res = await Api.get(url);
        this.logData = res?.data?.data || [];
      } catch (err) {
        this.$notify(
          err?.response?.data?.message || "something went wrong",
          "error"
        );
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style>
.waive-field {
  width: 100%;
  border: 1px solid #dce1e7;
  outline: none;
  border-radius: 6px;
  padding: 9px 15px;
  font-size: 14px;
  transition: all ease 0.6s;
}
#waiveEfeeLogs .modal-footer {
  display: none;
}
#waiveEfeeLogs .univ-btn {
  max-width: 100%;
}
#waiveEfeeLogs .modal-header {
  display: flex;
}
th {
  border-bottom: 0 !important;
  background: #fafbfd;
}
</style>
